import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ptm',
  templateUrl: './ptm.component.html',
  styleUrls: ['./ptm.component.scss']
})
export class PtmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
